/**
 * v5.1 Phase 52 — Hour-bucketed median duration trend for one agent.
 */
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function shortHour(iso) {
  if (!iso || iso.length < 16) return iso;
  // 2026-05-05T07:00:00Z → 05-05 07:00
  return `${iso.slice(5, 10)} ${iso.slice(11, 16)}`;
}

export default function PipelineTrendChart({ agentId, buckets = [] }) {
  const data = buckets.map((b) => ({
    bucket: shortHour(b.bucket),
    medianDurationMs: b.medianDurationMs,
    runs: b.runs,
  }));

  if (!agentId) {
    return (
      <p className="admin-page__hint">
        Select an agent in the table above to see its hourly trend.
      </p>
    );
  }
  if (!data.length) {
    return (
      <p className="admin-page__hint">
        No data for <code>{agentId}</code> in the selected window.
      </p>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={280}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
        <XAxis dataKey="bucket" stroke="var(--text-muted)" fontSize={12} />
        <YAxis stroke="var(--text-muted)" fontSize={12} allowDecimals={false} />
        <Tooltip
          contentStyle={{
            background: "var(--surface)",
            border: "1px solid var(--border)",
            borderRadius: "6px",
          }}
        />
        <Line
          type="monotone"
          dataKey="medianDurationMs"
          stroke="#4F46E5"
          strokeWidth={2}
          dot={false}
          name="Median ms"
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
